export default __webpack_public_path__ + "static/media/LoyaltyNone.fec34d85.svg";